export enum SurveyDirection {
  Next,
  Previous
}

export enum ProfilingMode {
  StepByStep,
  AutoAdvance,
  Group,
}
